module.exports = __webpack_public_path__ + "static/media/k5-alt-new.d0a17a54.glb";